import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { resetStates } from "../../../actions/Common";
import { filterOperatorServiceList, getListResult } from "../../../utils";
import { AgencyListPayload } from "../../../models/ProviderMaterials";
import { getMasterServiceProvider, getSendCommunicationAuthType } from "../../../actions/Master";
import { ingestProcess, postReAuthSubmit, uploadDocumentFile } from "../../../actions/ReferralAction";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";
import ReAuthTabs from "../components/ReAuthTabs";
import { ReAuthDetailsPayload } from "../../../constants/Referral";

const mapStateToProps = ({
    loggedInUserState,
    masterServiceProviderState,
    masterSendCommunicationAuthTypeState,
    masterReferralSourceState,
    patientFromMbiState,
    memberInfoDataState,
    disciplineListState,
    ingestProcessState,
    documentUploadState,
    patientInformationByIdState,
    reAuthDefaultValueState,
    reAuthSubmitState,
    reAuthReferralDetailState
}: ApplicationState) => ({
    loggedInUser: loggedInUserState.response,
    masterServiceProviderState: getListResult(filterOperatorServiceList(masterServiceProviderState.response, true, loggedInUserState.response)),
    serviceProviderListWithDetails: masterServiceProviderState.response,
    masterSendCommunicationAuthTypeState: getListResult(masterSendCommunicationAuthTypeState.response),
    masterReferralSourceState: getListResult(masterReferralSourceState.response),
    patientFromMbiState: patientFromMbiState.response,
    memberInfoDataState: memberInfoDataState.response,
    disciplineListState: disciplineListState.response,
    ingestProcessState: ingestProcessState.response,
    ingestProcessErrorState: ingestProcessState.error,
    documentUploadErrorState: documentUploadState.error,
    documentUploadState: documentUploadState.response,
    patientInformationByIdState: patientInformationByIdState.response,
    reAuthDefaultValueState: reAuthDefaultValueState.response,
    reAuthSubmitState: reAuthSubmitState.response,
    reAuthSubmitErrorState: reAuthSubmitState.error,
    reAuthReferralDetailState: reAuthReferralDetailState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    resetStates: (actionType: string, field?: string) => {
      dispatch(resetStates(actionType, field));
    },
    getMasterServiceProvider: (payload: AgencyListPayload) => {
      dispatch(getMasterServiceProvider(payload));
    },
    getSendCommunicationAuthType: () => {
      dispatch(getSendCommunicationAuthType());
    },
    ingestProcess: (payload: any) => {
      dispatch(ingestProcess(payload));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
    uploadDocumentFile: (payload: any) => {
      dispatch(uploadDocumentFile(payload));
    },
    postReAuthSubmit: (payload: ReAuthDetailsPayload) => {
      dispatch(postReAuthSubmit(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReAuthTabs);